/*
 * @Description: 
 * @Author: 
 * @Date: 2022-01-10 19:23:41
 * @LastEditTime: 2023-04-21 17:41:31
 * @LastEditors: dongqianqian
 * @Usage: 
 */
import Axios from '@/plugins/axios'
// 获取项目字典树
export function getDicList() {
  return Axios({
    url: `/api/project-management-module/dic-list`,
    method: 'get',
  })
}
// 获取字典信息
export function getDicInfoData(query) {
  return Axios({
    url: `/api/project-management-module/dictionary-info/${query}`,
    method: 'get',
  })
}
// 添加、修改项目字典信息
export function addDicData(query) {
  return Axios({
    url: `/api/project-management-module/set-dictionary-info`,
    method: 'post',
    data: query
  })
}
// 删除字典信息
export function delDicData(dicid) {
  return Axios({
    url: `/api/project-management-module/del-dictionary-info/${dicid}`,
    method: 'post',
  })
}
// 获取子节点数据
export function getDicChidData(query) {
  return Axios({
    url: `/api/project-management-module/dic-child/${query}`,
    method: 'get',
  })
}
//获取短信报警配置项目
export function getWarnData(data) {
  return Axios({
    url: `/api/waiting-processing-management-module/project-sms-settings?projectid=${data.projectid}`,
    method: 'get',
  })
}
//设置短信报警配置项目POST
export function pushWarnData(data) {
  return Axios({
    url: `/api/waiting-processing-management-module/set-project-sms-settings?projectid=${data.projectid}`,
    method: 'post',
    data
  })
}